// extracted by mini-css-extract-plugin
export default {"container":"HXFkdqY9YKLK6bpyBGRF","reverse":"nN2apsv5ERr9nAeizJJk","withAvatar":"rLE2w1w6Hx2qJfvN4xB5","withLink":"SepDUhccnUtJ2wAPgh0a"};